import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import menu2Fill from '@iconify/icons-eva/menu-2-fill'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Typography,
  Tooltip,
  Switch,
  FormControlLabel,
} from '@material-ui/core'
// components
import { MHidden } from '../../components/@material-extend'
//
import Searchbar from './Searchbar'
import AccountPopover from './AccountPopover'

import LanguagePopover from './LanguagePopover'
import ContactsPopover from './ContactsPopover'
import NotificationsPopover from './NotificationsPopover'
import SettingFullscreen from 'src/components/settings/SettingFullscreen'
import AIChatbot from './AIChatbot'
import ChatbotTestBackup from 'src/components/_dashboard/chatbot/ChatbotTestBackup.js'
// import Typography from 'src/theme/overrides/Typography'
import { Link, useNavigate } from 'react-router-dom'
import { Theme } from '@fullcalendar/react'
import useAuth from 'src/hooks/useAuth'
import { PATH_DASHBOARD } from 'src/routes/paths'
import FloatingChat from 'src/pages/dashboard/ChatModuleSignwise/FloatingChatButton'
import NoteStickyIndividual from './individualStickynote'
import NoteStickyIndividualPopup from './individualStickynotePopup'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { currentFacilityName, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
}

export default function DashboardNavbar({ onOpenSidebar, isCompact }) {
  const { loginWithUserId } = useAuth()
  const { enqueueSnackbar } = useSnackbar();
  let user = JSON.parse(window.localStorage.getItem('user'))
  let user_id = localStorage.getItem('user_id')
  let user_type = localStorage.getItem('user_type')
  let admin = false
  let parentId = user?.parent_id
  let addedByClient = user?.added_by_client
  let isFromAdmin = user?.isFromAdmin
  const [isActive, setIsActive] = useState(false);
  console.log('isFromAdmin', isFromAdmin)
  // ----------------------------------------------------------------------

  const DRAWER_WIDTH = isCompact ? 80 : 280
  const APPBAR_MOBILE = 64
  const APPBAR_DESKTOP = 92

  const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up('lg')]: {
      width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
    },
  }))

  const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_DESKTOP,
      padding: theme.spacing(0, 5),
    },
  }))

  // ----------------------------------------------------------------------

  const navigate = useNavigate()
  if (user_id != user?.user_id) {
    admin = true
  }

  const loginAsUser = () => {
    let isFromAdmin = false
    let isFromClient = false
    loginWithUserId(1, user_id, isFromClient, isFromAdmin)

    setTimeout(() => {
      if (user?.isVendor) {
        navigate(PATH_DASHBOARD.client.vendors, { state: true })
      } else if (user?.team_id) {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: user?.team_id, isTeam: true },
        })
      } else if (user?.driver_id) {
        const id = user?.driver_id
        navigate(`${PATH_DASHBOARD.transportation.viewdriver}/${id}`)
      } else {
        navigate(PATH_DASHBOARD.client.cards, { state: true })
      }
      window.location.reload()
    }, 1000)
  }

  const loginAsClient = () => {
    let isFromClient = false
    let swithUser = addedByClient ? parentId : user_id
    loginWithUserId(1, swithUser, isFromClient, isFromAdmin)

    setTimeout(() => {
      if (user?.isVendor) {
        navigate(PATH_DASHBOARD.client.vendors, { state: true })
      } else if (user?.team_id) {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: user?.team_id, isTeam: true },
        })
      } else if (user?.driver_id) {
        const id = user?.driver_id
        navigate(`${PATH_DASHBOARD.transportation.viewdriver}/${id}`)
      } else {
        navigate(PATH_DASHBOARD.client.cards, { state: true })
      }
      window.location.reload()
    }, 1000)
  }

const handleActiveToggle = async (checked) => {
  try {
    const response = await axios.post(`${REST_API_END_POINT}teams/update-user-active`, {
      user_id: user.user_id,
      online: checked ? 1 : 0
    });

    if (response?.data?.status === 1) {
      
      console.log('resresponse?.data?.status',response.data.message )
      setIsActive(checked);
      enqueueSnackbar(response.data.message, { variant: 'success' });
    }
    else{
      enqueueSnackbar(response.data.message, { variant: 'error' });
    }
  } catch (err) {
    console.error(err);
  }
};

  useEffect(()=>{
    const fetchUserData = async ()=>{
      try {
        const response = await axios.post(`${REST_API_END_POINT}teams/get-user-active`);
        if (response.data.status === 1) {
          const data = response?.data?.data
          const active = data?.online === 1 ? true : false
          setIsActive(active)
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchUserData();
  },[])

  console.log('$$$$$$$$$$$$$$$^^^^^^^^^^^^^^', user)
  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            width: '100%',
          }}
        >
          {/* <FloatingChat /> */}
          {/* <Typography variant="h2" sx={{ml:25}}>{currentFacilityName}</Typography> */}
          {user && admin && (
            <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'nowrap',
                minWidth: 0, // important for ellipsis
                flex: 1,     // allow it to grow/shrink
              }}
            >
              <Tooltip title={`Logged in as ${user != null ? user.first_name : ''}`}>
                <Typography
                  variant="h5"
                  noWrap
                  sx={{
                    maxWidth: '320px', // or adjust as needed
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Logged in as {user != null ? user.first_name : ''}
                </Typography>
              </Tooltip>              
              {addedByClient && !isFromAdmin ? (
                ''
              ) : (
                <Button
                  variant="outlined"
                  type="submit"
                  // component={RouterLink}
                  // to={PATH_DASHBOARD.client.cards}
                  onClick={loginAsUser}
                  sx={{ mb: 0, mt: 0 }}
                >
                  Switch to {user_type == 8 ? 'Prod Manager' : 'Admin'}
                </Button>
              )}
              {addedByClient ? (
                <Button
                  variant="outlined"
                  type="submit"
                  // component={RouterLink}
                  // to={PATH_DASHBOARD.client.cards}
                  onClick={loginAsClient}
                  sx={{ mb: 0, mt: 0 }}
                >
                  Switch to Client
                </Button>
              ) : (
                ''
              )}
              </Box>
            </>
          )}
        </Box>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={{ xs: 0.5, sm: 1.5 }}>
          {/* {
             user?.user_id === 667 ?
              <Stack display={'flex'} flexDirection={'row'} alignItems={'center'} ml={1} gap={2}>
                <Typography variant='body2' sx={{whiteSpace:'nowrap'}}>Support Agent</Typography>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                    />
                  }
                  labelPlacement="end"
                  label={!isActive ? "Offline" : "Online"}
                  checked={isActive}
                  onChange={(e) => handleActiveToggle(e.target.checked)}
                  sx={{ mt: 0,
                    '& .MuiFormControlLabel-label': {
                      color: isActive ? 'green' : 'red',
                      fontWeight: 700,
                    },
                  }}
                />
              </Stack>:''
          } */}
          {/* <LanguagePopover /> */}

    <NoteStickyIndividualPopup/>
          {/* <ChatbotTestBackup /> */}
          {/* <AIChatbot/> */}
          <SettingFullscreen />
          {/* <NotificationsPopover /> */}

          {/* <ContactsPopover /> */}
          {/* <AccountPopover /> */}
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  )
}
